import React, { useState, lazy } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function FlavorShowcase() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slides = [{
    image: 'https://cdn.magicpatterns.com/uploads/dwiSMVREuhm6zXoUM3Z5cG/hf_20260301_202654_4192a041-4166-4d36-9a9c-61c7388d41eb.jpg',
    label: 'Flan de Coco'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/5MdFH3wG3qYfQHzapWnfww/hf_20260301_202701_f693580f-8102-4973-89a4-ce12c6d8e30a_(1).jpg',
    label: 'Flan Clásico'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/9BayxCJfkRrRWCx1u2QaG1/hf_20260301_202651_ca5e6c18-ff4d-48a5-af89-66698b6ca40d.jpg',
    label: 'Flan de Chocolate'
  }];
  const prev = () => setCurrentIndex(i => i === 0 ? slides.length - 1 : i - 1);
  const next = () => setCurrentIndex(i => i === slides.length - 1 ? 0 : i + 1);
  return <section className="py-10 md:py-20 px-4 bg-brown-dark text-cream" data-id="element-83">
      <div className="max-w-5xl mx-auto" data-id="element-84">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-caramel mb-8 md:mb-12" data-id="element-85">
          Algunos tipos de flanes que aprenderas a hacer HOY
        </h2>

        {/* Carousel */}
        <div className="relative" data-id="element-86">
          {/* Navigation Arrows */}
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 md:-translate-x-6 z-10 bg-white/90 hover:bg-white text-brown-dark w-10 h-10 md:w-12 md:h-12 rounded-full shadow-lg flex items-center justify-center transition-all" data-id="element-87">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-88" />
          </button>
          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 md:translate-x-6 z-10 bg-white/90 hover:bg-white text-brown-dark w-10 h-10 md:w-12 md:h-12 rounded-full shadow-lg flex items-center justify-center transition-all" data-id="element-89">
            <ChevronRightIcon className="w-6 h-6" data-id="element-90" />
          </button>

          {/* Slides Container */}
          <div className="overflow-hidden rounded-2xl" data-id="element-91">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${currentIndex * 100}%)`
          }} data-id="element-92">
              {slides.map((slide, i) => <div key={i} className="w-full flex-shrink-0 px-2" data-id="element-93">
                  <div className="relative rounded-2xl overflow-hidden aspect-[16/9] shadow-xl border-4 border-white/50" data-id="element-94">
                    <img src={slide.image} alt={slide.label} className="w-full h-full object-cover" loading="lazy" data-id="element-95" />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6" data-id="element-96">
                      <p className="font-heading font-bold text-xl md:text-2xl text-white drop-shadow-lg" data-id="element-97">
                        {slide.label}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-98">
            {slides.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} className={`w-3 h-3 rounded-full transition-all ${i === currentIndex ? 'bg-caramel w-8' : 'bg-white/40 hover:bg-white/60'}`} data-id="element-99" />)}
          </div>
        </div>

        <div className="mt-6 md:mt-10 text-center" data-id="element-100">
          <p className="text-xl md:text-2xl font-heading font-semibold text-caramel italic" data-id="element-101">
            Y un montón de combinaciones que hacen que te pidan: "dame otro
            sabor también"
          </p>
          <p className="text-2xl font-bold mt-4 tracking-widest text-white" data-id="element-102">
            …Y MUCHAS MÁS.
          </p>
        </div>
      </div>
    </section>;
}